<div class="interurbain-page">

  <!-- ─── En-tête ─────────────────────────────────────────────── -->
  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title">
        <i class="fal fa-route"></i>
        Commandes interurbaines
      </h1>
      <p class="page-header__sub">Express · Standard · Transit interurbain</p>
    </div>
    <div class="header-actions">
      <button class="btn-nouvelle-commande" (click)="router.navigate(['/commande/enregistrer'], { queryParams: { mode: 'interurbain' } })">
        <i class="fal fa-plus"></i>
        Nouvelle commande interurbaine
      </button>
      <button class="btn-refresh" (click)="charger()" [disabled]="indicateurChargement">
        <i class="fal fa-sync" [class.fa-spin]="indicateurChargement"></i>
        Actualiser
      </button>
    </div>
  </div>

  <!-- ─── KPIs ─────────────────────────────────────────────────── -->
  <div class="kpi-grid">
    <div class="kpi-card kpi-card--blue">
      <div class="kpi-card__icon"><i class="fal fa-boxes"></i></div>
      <div class="kpi-card__body">
        <span class="kpi-card__value">{{ kpis.total }}</span>
        <span class="kpi-card__label">Total chargé</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--teal">
      <div class="kpi-card__icon"><i class="fal fa-truck-moving"></i></div>
      <div class="kpi-card__body">
        <span class="kpi-card__value">{{ kpis.enTransit }}</span>
        <span class="kpi-card__label">En transit / distrib.</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--green">
      <div class="kpi-card__icon"><i class="fal fa-check-circle"></i></div>
      <div class="kpi-card__body">
        <span class="kpi-card__value">{{ kpis.livrees }}</span>
        <span class="kpi-card__label">Livrées</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--orange">
      <div class="kpi-card__icon"><i class="fal fa-coins"></i></div>
      <div class="kpi-card__body">
        <span class="kpi-card__value">{{ kpis.aEncaisser }}</span>
        <span class="kpi-card__label">Encaissements en attente</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--red" *ngIf="kpis.incidents > 0">
      <div class="kpi-card__icon"><i class="fal fa-exclamation-triangle"></i></div>
      <div class="kpi-card__body">
        <span class="kpi-card__value">{{ kpis.incidents }}</span>
        <span class="kpi-card__label">Incidents</span>
      </div>
    </div>
  </div>

  <!-- ─── Filtres ───────────────────────────────────────────────── -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()"
             placeholder="Rechercher (réf, expéditeur, destinataire…)" />
    </div>
    <select [(ngModel)]="statutFiltre" (ngModelChange)="appliquerFiltres()" class="filtre-select">
      <option *ngFor="let s of STATUTS" [value]="s.valeur">{{ s.libelle }}</option>
    </select>
    <select [(ngModel)]="typeFiltre" (ngModelChange)="appliquerFiltres()" class="filtre-select">
      <option *ngFor="let t of TYPES" [value]="t.valeur">{{ t.libelle }}</option>
    </select>
    <button class="btn-reset" (click)="reinitialiserFiltres()" *ngIf="recherche || statutFiltre || typeFiltre">
      <i class="fal fa-times"></i> Réinitialiser
    </button>
  </div>

  <!-- ─── Chargement ────────────────────────────────────────────── -->
  <div class="etat-chargement" *ngIf="indicateurChargement">
    <div class="spinner"></div>
    <span>Chargement des commandes interurbaines…</span>
  </div>

  <!-- ─── Vide ─────────────────────────────────────────────────── -->
  <div class="etat-vide" *ngIf="!indicateurChargement && commandesFiltrees.length === 0">
    <i class="fal fa-route"></i>
    <p>Aucune commande interurbaine trouvée.</p>
  </div>

  <!-- ─── Tableau ───────────────────────────────────────────────── -->
  <div class="table-wrapper" *ngIf="!indicateurChargement && commandesFiltrees.length > 0">
    <table class="data-table">
      <thead>
        <tr>
          <th>Référence</th>
          <th>Type</th>
          <th>Origine → Destination</th>
          <th>Statut</th>
          <th>Livreur</th>
          <th>Montant</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of commandesFiltrees">
          <td class="col-ref">
            <span class="ref-badge">{{ c.numeroCommande ?? '—' }}</span>
            <small class="ref-date">{{ c.dateCreation | date:'dd/MM/yy' }}</small>
          </td>
          <td>
            <span class="type-pill">{{ libelleType(c.typeEnvoi) }}</span>
          </td>
          <td class="col-zones">
            <ng-container *ngIf="c.trajetZoneDepartNom || c.trajetZoneDestinationNom; else lieuTexte">
              <span class="zone-depart">{{ c.trajetZoneDepartNom ?? '—' }}</span>
              <i class="fal fa-arrow-right zone-arrow"></i>
              <span class="zone-dest">{{ c.trajetZoneDestinationNom ?? '—' }}</span>
            </ng-container>
            <ng-template #lieuTexte>
              <ng-container *ngIf="c.lieuDepartTexte || c.lieuArriveeTexte; else naTemplate">
                <span class="zone-depart">{{ c.lieuDepartTexte ?? '—' }}</span>
                <i class="fal fa-arrow-right zone-arrow"></i>
                <span class="zone-dest">{{ c.lieuArriveeTexte ?? '—' }}</span>
              </ng-container>
              <ng-template #naTemplate><span class="zone-na">—</span></ng-template>
            </ng-template>
          </td>
          <td>
            <span class="statut-badge" [ngClass]="badgeStatut(c.statut)">
              {{ libelleStatut(c.statut) }}
            </span>
          </td>
          <td class="col-livreur">
            <ng-container *ngIf="c.livreurNom; else nonAssigne">
              <div class="livreur-cell livreur-cell--assigne">
                <span class="livreur-cell__avatar">{{ (c.livreurNom || '?')[0].toUpperCase() }}</span>
                <span class="livreur-cell__nom">{{ c.livreurNom }}</span>
              </div>
            </ng-container>
            <ng-template #nonAssigne>
              <span class="livreur-cell livreur-cell--vide">
                <i class="fal fa-user-slash"></i> Non assigné
              </span>
            </ng-template>
          </td>
          <td class="col-montant">
            <strong>{{ (c.coutEstime ?? c.montantAPayer ?? 0) | number:'1.0-0' }} F</strong>
          </td>
          <td class="col-actions">
            <button class="btn-action btn-action--primary" (click)="voirDetail(c.id)" title="Voir le détail">
              <i class="fal fa-eye"></i>
            </button>
            <button *ngIf="c.statut !== 'LIVRE' && c.statut !== 'ANNULE'"
                    class="btn-action"
                    [class.btn-action--assign]="!c.livreurNom"
                    [class.btn-action--warning]="c.livreurNom"
                    [disabled]="assignationEnCoursIds.has(c.id)"
                    (click)="ouvrirPanelAssignation(c)"
                    [title]="c.livreurNom ? 'Modifier le livreur' : 'Assigner un livreur'">
              <i class="fal" [class.fa-user-plus]="!c.livreurNom" [class.fa-user-edit]="c.livreurNom"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination" *ngIf="totalPages > 1">
      <button (click)="changerPage(pageCourante - 1)" [disabled]="pageCourante === 1">
        <i class="fal fa-chevron-left"></i>
      </button>
      <ng-container *ngFor="let p of pages">
        <button (click)="changerPage(p)" [class.active]="p === pageCourante"
                *ngIf="p === 1 || p === totalPages || Math.abs(p - pageCourante) <= 2">
          {{ p }}
        </button>
        <span class="pagination-ellipsis"
              *ngIf="(p === pageCourante - 3 && pageCourante > 4) || (p === pageCourante + 3 && pageCourante < totalPages - 3)">
          …
        </span>
      </ng-container>
      <button (click)="changerPage(pageCourante + 1)" [disabled]="pageCourante === totalPages">
        <i class="fal fa-chevron-right"></i>
      </button>
    </div>
  </div>

</div>

<!-- ─── Panel assignation livreur ───────────────────────────────────────────── -->
<div class="assign-sheet-backdrop" *ngIf="panelAffectationOuvert" (click)="fermerPanelAssignation()"></div>
<aside class="assign-sheet" *ngIf="panelAffectationOuvert" aria-modal="true" role="dialog">
  <div class="assign-sheet-header">
    <div>
      <h3>{{ commandeCibleAffectation?.livreurNom ? 'Modifier le livreur' : 'Affecter un livreur' }}</h3>
      <p class="assign-sheet-lead">
        Commande <strong>{{ commandeCibleAffectation?.numeroCommande ?? '#' + commandeCibleAffectation?.id }}</strong>
      </p>
      <p class="assign-sheet-sub" *ngIf="commandeCibleAffectation?.livreurNom">
        Livreur actuel : <strong>{{ commandeCibleAffectation.livreurNom }}</strong>
      </p>
    </div>
    <button type="button" class="assign-sheet-close"
            (click)="fermerPanelAssignation()"
            [disabled]="commandeCibleAffectation && assignationEnCoursIds.has(commandeCibleAffectation.id)"
            aria-label="Fermer">✕</button>
  </div>

  <div class="assign-sheet-search">
    <input type="search" class="form-input" placeholder="Nom ou téléphone"
           autocomplete="off" [(ngModel)]="rechercheLivreur" (ngModelChange)="filtrerLivreursPanel()">
  </div>

  <div class="assign-sheet-body">
    <div class="assign-sheet-loading" *ngIf="chargementLivreurs">
      <div class="spinner"></div>
      <p>Chargement des livreurs...</p>
    </div>
    <div class="assign-sheet-empty" *ngIf="!chargementLivreurs && livreursPanelFiltres.length === 0">
      Aucun livreur disponible trouvé.
    </div>
    <div class="assign-sheet-grid" *ngIf="!chargementLivreurs && livreursPanelFiltres.length > 0">
      <article class="assign-sheet-card" *ngFor="let livreur of livreursPanelFiltres">
        <div class="assign-sheet-card-head">
          <h4>{{ livreur.nom }} {{ livreur.prenom }}</h4>
          <span class="tag-dispo">Disponible</span>
        </div>
        <p>📱 {{ livreur.contact || '—' }}</p>
        <p>📍 {{ livreur.adresse || 'Adresse non renseignée' }}</p>
        <p>📦 {{ livreur.nombreCommandesEnCours || 0 }} course(s) en cours</p>
        <p *ngIf="livreur.vehiculeActuel">
          <span *ngIf="libelleTypeVehicule(livreur) as tv">{{ tv }} — </span>
          {{ livreur.vehiculeActuel.marque }} {{ livreur.vehiculeActuel.modele }}
          <span class="tag-immat">{{ livreur.vehiculeActuel.immatriculation }}</span>
        </p>
        <p *ngIf="!livreur.vehiculeActuel" style="color:#9ca3af;font-style:italic;">Véhicule non renseigné</p>
        <button type="button" class="btn btn-primary assign-sheet-cta"
                [disabled]="commandeCibleAffectation && assignationEnCoursIds.has(commandeCibleAffectation.id)"
                (click)="assignerLivreurDepuisPanel(livreur)">
          {{ commandeCibleAffectation?.livreurNom ? 'Remplacer par ce livreur' : 'Assigner ce livreur' }}
        </button>
      </article>
    </div>
  </div>
</aside>
